import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './version.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { Version } from "model/system/version.model";

export interface VersionDetailsProps extends DetailsStateAndDispatchProps<Version>,
  RouteComponentProps, StateProps, DispatchProps {
}
const VersionDetails: FC<VersionDetailsProps> = (props) => {
  return (
    <DetailsPage<Version>
      title={'详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<Version>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ version }: RootState) => ({
  entity: version.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(VersionDetails);
